import { authEventEmitter } from './authEventEmitter'

export const eventEmitters = {
  authEventEmitter,
}
